import LoadingIconComponent from 'components/utils/iconComponents/LoadingIconComponent';
import React from 'react';

export const ActionButton = ({
  onClick,
  message,
  disabled,
  loading,
}: {
  onClick: () => void;
  message: string;
  disabled?: boolean;
  loading?: boolean;
}) => {
  onClick = onClick || (() => {});
  message = message || 'Publicar';
  disabled = disabled || false;
  loading = loading || false;
  return (
    <div className='pl-2 pt-2 pb-2 pr-6'>
      <div
        className={`text-white bg-primary-700 border border-primary-700 inline-flex items-center px-4 py-2 font-semibold leading-6 text-sm shadow rounded-md transition ease-in-out duration-150 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        onClick={disabled ? undefined : onClick}
        aria-disabled={disabled}
      >
        <div>
          {loading ? <LoadingIconComponent /> : message}
        </div>
      </div>
    </div>
  );
};
